import { ExpandAltOutlined, PieChartOutlined, ShoppingCartOutlined } from "@ant-design/icons";

export const skladMenuItems = [
    {
        key: '1',
        icon: <ShoppingCartOutlined  style={{fontSize: '18px'}} />,
        label: "Kirim",
        link: '/'
    },
    {
        key: '2',
        icon: <PieChartOutlined style={{fontSize: '18px'}} />,
        label: "Kirimlar tarixi",
        link: '/history'
    },
    {
        key: '3',
        icon: <PieChartOutlined style={{fontSize: '18px'}} />,
        label: "Skladdagi tovarlar",
        link: '/zaxira'
    },
    {
        key: '4',
        icon: <ExpandAltOutlined style={{fontSize: '18px'}} />,
        label: "Xarajatlar",
        link: '/expenses'
    },
    {
        key: '5',
        icon: <ExpandAltOutlined style={{fontSize: '18px'}} />,
        label: "Xisobotlar",
        link: '/report'
    },
]